dmx.config.mapping['a[href]'] = 'link';
